<template>
  <section v-if="isPermission('location-amenities.list')">
    <ListingLayout
      :sub-screen="1"
      :is-loading="isLoading"
      :meta="meta"
      :headers="_headers"
      :items="list"
      no-filters
      :filter-names="filterNames"
      @filterOption="onFiltersChange"
    >
      <template v-slot:actions="{ item }">
        <v-icon
          v-if="$admin.can('location-amenities.edit')"
          class="mr-2"
          small
          @click="editItem(item)"
        >
          mdi-pencil
        </v-icon>
        <v-icon
          v-if="$admin.can('location-amenities.delete')"
          class="mr-2"
          small
          @click="deleteItem(item)"
        >
          mdi-delete
        </v-icon>
      </template>

      <!-- add Filters -->
      <!-- <template #addFilters>
        <v-card v-if="authUser.isAdmin">
          
        </v-card>
      </template> -->
      <!-- add Filters -->

      <!-- Action Modals -->
      <template #actionModals>
        <div>
          <confirmation-modal
            v-if="$admin.can('location-amenities.delete')"
            :is-visible="deleteModal"
            :toggle="toggleDeleteModal"
            :row="selectedRow"
          />
        </div>
      </template>
      <!-- Action Modals -->
    </ListingLayout>
  </section>
</template>

<script>
import { ListingLayoutMixins } from "@/mixins/ListingLayoutMixins";
import { mapGetters } from "vuex";
// import { debounce } from "lodash";
export default {
  components: {
    ListingLayout: () => import("@/layouts/section/ListingLayout.vue"),
    ConfirmationModal: () =>
      import("@/components/Modals/ConfirmationModal.vue"),
  },
  mixins: [ListingLayoutMixins],
  props: {
    row: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      filters: {},
      subFilters: {},

      headers: [
        {
          text: this.$t("id"),
          align: "left",
          sortable: true,
          value: "id",
        },
        {
          text: this.$t("name"),
          align: "left",
          sortable: false,
          value: "amenity_name",
        },
        {
          text: this.$t("status"),
          align: "left",
          sortable: false,
          value: "amenity_status",
        },
        ...(this.$admin.hasAccessTo("location-amenities.delete") ||
        this.$admin.hasAccessTo("location-amenities.edit")
          ? [
              {
                text: this.$t("actions"),
                align: "left",
                sortable: false,
                value: "actions",
              },
            ]
          : []),
      ],
    };
  },
  computed: {
    ...mapGetters({
      authUser: "getUser",
      isLoading: "csmsLocations/getSubLoading",
      meta: "csmsLocations/getAmenitiesMeta",
      list: "csmsLocations/getAmenitiesList",
    }),
    _headers() {
      // computed headers for showing columns to role based
      return this.headers.filter(
        (header) =>
          header.showAdmin === undefined ||
          (header.showAdmin != undefined &&
            header.showAdmin === this.authUser.isAdmin)
      );
    },

    // listById() {
    //   const id = this.row?.id;
    //   const arr = this.list.filter((r) => r.id === id);
    //   return arr;
    // },

    filterNames() {
      return [];
    },
  },
  watch: {
    options() {
      this.fetchData();
    },
  },
  // beforeDestroy() {
  //   const params = {
  //     name: "md_makes",
  //     filters: this.options,
  //   };
  //   this.$store.commit("redirect/SET_FILTERS", params);
  // },
  methods: {
    isPermission(val) {
      return this.$admin.can(val);
    },
    async fetchData() {
      const params = {
        ...this.options,
        location_id: this.row.id,
      };
      await this.$store
        .dispatch("csmsLocations/amenitiesList", params)
        .then(() => {
          if (this.options.page > (this.meta?.lastPage || 1)) {
            this.options.page = 1;
          }
        });
    },

    // Confirmation of Delete Row
    async deleteSelectedRow(row) {
      try {
        await this.$store.dispatch("csmsLocations/destroyAmenities", row);
        this.$store.dispatch("alerts/success", this.$t("deleted_successfully"));
        this.toggleDeleteModal("close");
      } catch (error) {
        this.$store.dispatch("alerts/error", error.response?.data?.message);
      }
    },
  },
};
</script>
